import { useCallback, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import DossierSecret from './DossierSecret';
import './Navbar.css';

const LINKS = [
  { to: '/', label: 'Accueil' },
  { to: '/notre-histoire', label: 'Notre histoire' },
  { to: '/le-jour-j', label: 'Le jour J' },
  { to: '/voyage', label: 'Voyage' },
  { to: '/musique', label: 'Musique' },
  { to: '/faq', label: 'FAQ' },
  { to: '/rsvp', label: 'RSVP' },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const [dossierOuvert, setDossierOuvert] = useState(false);
  const logoClicks = useRef({ count: 0, last: 0 });

  // 2 clics d'affilée sur le logo ouvrent le dossier secret.
  const handleLogoClick = () => {
    setOpen(false);
    const now = Date.now();
    const clicks = logoClicks.current;
    clicks.count = now - clicks.last < 800 ? clicks.count + 1 : 1;
    clicks.last = now;
    if (clicks.count >= 2) {
      clicks.count = 0;
      setDossierOuvert(true);
    }
  };

  const fermerDossier = useCallback(() => setDossierOuvert(false), []);

  return (
    <header className="navbar">
      {dossierOuvert && <DossierSecret onClose={fermerDossier} />}
      <div className="navbar-inner container">
        <NavLink to="/" className="navbar-logo" onClick={handleLogoClick}>
          G&nbsp;<span className="navbar-logo-amp">&amp;</span>&nbsp;H
        </NavLink>

        <button
          className="navbar-toggle"
          aria-label="Ouvrir le menu"
          onClick={() => setOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`navbar-links ${open ? 'navbar-links-open' : ''}`}>
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
